import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
} from 'vue-router';

import {
  EmptyState,
  EmptyStateRoute,
  queryParamsPipe,
} from '@pohlcon/design-system';

import {
  useAuthStore,
  useMainStore,
  useProductsStore,
  useWallStructuresStore,
} from '~/store';
import {
  DataTablesView,
  ErrorView,
  HomeView,
  LicensesView,
  PrintOutView,
  SelectView,
} from '~/views';

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/select",
    name: "Select",
    component: SelectView,
    beforeEnter (to, from, next) {
      const mainStore = useMainStore();
      mainStore.activeStepId = "select";
      next();
    }
  },
  {
    path: "/print_out",
    name: "PrintOut",
    component: PrintOutView,
    beforeEnter (to, from, next) {
      if (
        useProductsStore().selectedProduct &&
        useWallStructuresStore().selectedWallStructure
      )
        return next();
      next("/select");
    },
  },
  {
    path: "/licenses",
    name: "Licenses",
    component: LicensesView,
  },
  {
    path: "/error",
    name: "Error",
    component: ErrorView,
  },
  {
    path: "/data",
    name: "Data",
    component: DataTablesView,
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore();
      if (!authStore.isAuthenticated) {
        authStore.login();
      }
      next();
    },
  },
  EmptyStateRoute[404],
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: EmptyState[401],
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore();
      authStore.handleCallback().then((returnUrl) => {
        if (returnUrl) {
          window.location.href = returnUrl;
          return;
        }
        next('/data');
      }).catch(() => {
        authStore.login();
      });
    },
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

const LIST_OF_COMMON_QUERIES = ["lang", "embed"];
router.beforeEach(queryParamsPipe(LIST_OF_COMMON_QUERIES));

export default router;
